import { Dictionary, VueRouter } from 'vue-router/types/router';

export class Navigation {
    private router: VueRouter;

    constructor(router: VueRouter) {
        this.router = router;
    }

    redirectTo(
        componentName: string,
        params: Dictionary<string> | null = null,
        queryString: Dictionary<string> | null = null
    ): Promise<void> {
        let currentParams = this.router.currentRoute.params;
        if (params !== null) {
            currentParams = { ...currentParams, ...params };
        }
        let currentQueryString = this.router.currentRoute.query;
        if (queryString !== null) {
            currentQueryString = { ...currentQueryString, ...queryString };
        }
        return new Promise((resolve) => {
            this.router
                .replace({
                    name: componentName,
                    params: currentParams,
                    query: currentQueryString,
                })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    //do nothing
                });
        });
    }

    getUrl(
        componentName: string,
        params: Dictionary<string> | null = null,
        queryString: Dictionary<string> | null = null
    ): string {
        let currentParams = this.router.currentRoute.params;
        if (params !== null) {
            currentParams = { ...currentParams, ...params };
        }
        let currentQueryString = this.router.currentRoute.query;
        if (queryString !== null) {
            currentQueryString = { ...currentQueryString, ...queryString };
        }
        return this.router.resolve({
            name: componentName,
            params: currentParams,
            query: currentQueryString,
        }).href;
    }

    get currentPath(): string {
        return this.router.currentRoute.fullPath;
    }

    matches(...name: string[]): boolean {
        return this.router.currentRoute.matched.some((x) => name.some((y) => x.name === y));
    }
}
